import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  standardModalHeader: {
    position: 'relative',
    background: '#f5f5f5',
  },
  standardTopbar: {
    background: '#2C3F52',
    color: '#797979',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 12px',
  },
  standardTopbarTitle: {
    color: '#fff',
    fontWeight: 600,
  },
  standardTopbarClose: {
    background: 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: 18,
    width: 32,
    height: 32,
    cursor: 'pointer',
  },
  standardHeaderImage: {
    width: '100%',
    maxHeight: '400px',
    borderRadius: '3px 3px 0 0',
    display: 'block',
  },
  standardVideoContainer: {
    position: 'relative', 
    width: '100%', 
    height: 0, 
    paddingBottom: '56.25%', 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    background: '#f5f5f5',
  },
  standardVideo: {
    position: 'absolute',
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)', 
    width: '90%', 
    height: '90%', 
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  containerCloseButton: {
    position: "absolute", 
    top: 0, 
    right: 0, 
    zIndex: 999
  },
  standardCloseButton: {
    background: 'transparent',
    border: 'none',
    color: '#333',
    fontSize: 22,
    width: 36,
    height: 36,
    cursor: 'pointer',
    transition: 'color 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    '&:hover': {
      color: '#666',
    },
  },
  standardModalContainer: {
    padding: '16px 24px 24px 24px',
    height: '100%',
    overflowY: 'auto',
    fontFamily: '"open sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  standardHeading: {
    margin: '8px 0 4px 0',
    textAlign: 'center',
    fontWeight: 600,
    fontSize: 20,
    color: '#111',
  },
  standardSection: {
    marginTop: 12,
    fontSize: 16,
    lineHeight: 1.6,
    color: '#222',
  },
}));

export default useStyles;
